<template>
  <div class="on-focus__predefined-queries-container q-text-dark">
    <div class="on-focus__predefined-queries-content q-row" v-for="section in sections" :key="section">
      <QueriesContainer v-if="showPredefinedQueries"
                        :queries="section.queries"
                        :queries-header="section.header"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {defineProps, inject} from "vue";
import QueriesContainer from '../Queries/QueriesContainer.vue'

const props = defineProps(['sections'])

const SmartSearchConfig = inject('SmartSearchConfig').value;
const {enabled, sections} = SmartSearchConfig.onfocus.predefinedQueries
const showPredefinedQueries = props.sections.length > 0 && enabled

</script>

<style scoped>
a {
  cursor: pointer;
}
</style>